import { Cargo } from '../types/cargo.types';
import { Permissao } from '../types/permissao.type';
import api from './api';


interface LoginResponse {
  token: string;
  usuario: {
    id: number;
    nome: string;
    email: string;
    isAdmin: boolean;
  
    permissoes:Permissao[];
    cargo:Cargo[]
  };
  
}

export const authService = {
  async login(nomeUsuario: string, senha: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', {
      nomeUsuario,
      senha
    });
    
    if (response.data.token) {
      localStorage.setItem('@GM:token', response.data.token);
      api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    
    return response.data;
  },

  logout() {
    localStorage.removeItem('@GM:token');
    delete api.defaults.headers.common['Authorization'];
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('@GM:token');
  }
}; 